import type { IconType } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

export const FEEDBACK_MOOD_VALUES = [0, 1, 2, 3, 4, 5] as const

export type FeedbackMoodValue = (typeof FEEDBACK_MOOD_VALUES)[number]

export const FeedbackTopic = {
  PRODUCT: 'product',
  DEVELOPER_EXPERIENCE: 'developer-experience',
  INTEGRATION_EXPERIENCE: 'integration-experience',
  PERFORMANCE_RELIABILITY: 'performance-reliability',
  DOCUMENTATION_LEARNING: 'documentation-learning',
  FEATURE_REQUEST: 'feature-request',
  BUG_REPORT: 'bug-report',
  OTHER: 'other',
} as const

export type FeedbackTopicValue = (typeof FeedbackTopic)[keyof typeof FeedbackTopic]

export type FeedbackMoodOption = {
  value: FeedbackMoodValue
  icon: IconType
  labelKey: string
}

export const FEEDBACK_MOOD_OPTIONS: FeedbackMoodOption[] = [
  { value: 0, icon: Icon.EmojiAngryRegular, labelKey: 'moods.angry' },
  { value: 1, icon: Icon.EmojiSadRegular, labelKey: 'moods.sad' },
  { value: 2, icon: Icon.EmojiMehRegular, labelKey: 'moods.meh' },
  { value: 3, icon: Icon.EmojiRegular, labelKey: 'moods.happy' },
  { value: 4, icon: Icon.DSEmojiCustom, labelKey: 'moods.excited' },
]

export type FeedbackTopicOption = {
  value: FeedbackTopicValue
  labelKey: string
}

export const FEEDBACK_TOPIC_OPTIONS: FeedbackTopicOption[] = [
  { value: FeedbackTopic.PRODUCT, labelKey: 'topics.product' },
  { value: FeedbackTopic.DEVELOPER_EXPERIENCE, labelKey: 'topics.developer-experience' },
  { value: FeedbackTopic.INTEGRATION_EXPERIENCE, labelKey: 'topics.integration-experience' },
  { value: FeedbackTopic.PERFORMANCE_RELIABILITY, labelKey: 'topics.performance-reliability' },
  { value: FeedbackTopic.DOCUMENTATION_LEARNING, labelKey: 'topics.documentation-learning' },
  { value: FeedbackTopic.FEATURE_REQUEST, labelKey: 'topics.feature-request' },
  { value: FeedbackTopic.BUG_REPORT, labelKey: 'topics.bug-report' },
  { value: FeedbackTopic.OTHER, labelKey: 'topics.other' },
]
